import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ROUTES } from '@/router/routes';
import router from '@/router';
import Vue3autocounter from 'vue3-autocounter';


export default /*#__PURE__*/_defineComponent({
  __name: 'StartRoundContdown',
  setup(__props) {

function startRound() {
  router.push(ROUTES.PLAY);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Vue3autocounter), {
    ref: "game-countdown",
    class: "number",
    startAmount: 4,
    endAmount: 1,
    duration: 4,
    separator: "",
    autoinit: true,
    onFinished: _cache[0] || (_cache[0] = ($event: any) => (startRound()))
  }, null, 512))
}
}

})